// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
import * as React from 'react';
import * as Import from '@ta/platform.import';
import type { EditLinkPostModalViewProps } from '@ta/public.content-uploader';
import { localize } from '@ta/common.i18n';
import { ModalView } from '@ta/overlays.modal';
import { TitleBar } from '@ta/modal.headers';
import { LoadingSpinner } from '@ta/styleguide.loading';
import { Global, Closer } from '@ta/overlays.managers';
import styles from './EditLinkPostModal.less';

const EditLinkPostModalView = Import.component.onUsage<_, EditLinkPostModalViewProps>(
  () => import('@ta/public.content-uploader'),
  'EditLinkPostModalView',
  <ModalView
    header={<TitleBar displayType="LEFT_ALIGN_GRAY">{localize('trips_edit_CTA')}</TitleBar>}
  >
    <div className={styles.wrapper}>
      <LoadingSpinner />
    </div>
  </ModalView>,
);

type Props = {|
  /* The modal view props  */
  ...EditLinkPostModalViewProps,
  /* the name of the modal.  Necessary because the Opener will use the same name */
  modalName: string,
|};

type DeferredEditLinkPostModalViewProps = {|
  ...EditLinkPostModalViewProps,
  closeGlobals: () => mixed,
|};

const DeferredEditLinkPostModalView = ({
  closeGlobals,
  onClose,
  ...modalProps
}: DeferredEditLinkPostModalViewProps) => {
  // Hard to test
  /* istanbul ignore next */
  const passThroughOnClose = React.useCallback(() => {
    if (onClose) {
      onClose();
    }
    closeGlobals();
  }, [onClose, closeGlobals]);

  return <EditLinkPostModalView {...modalProps} onClose={passThroughOnClose} />;
};

const EditLinkPostModal = ({ modalName, ...linkPostModalProps }: Props) => (
  <Global name={modalName}>
    <Closer>
      {close => <DeferredEditLinkPostModalView {...linkPostModalProps} closeGlobals={close} />}
    </Closer>
  </Global>
);

export default EditLinkPostModal;
